import { Award, Users, Target, Rocket } from 'lucide-react';

export default function About() {
  const values = [
    {
      icon: Target,
      title: 'Client-Centric Approach',
      description: 'We prioritize understanding your unique business challenges and deliver tailored solutions that drive measurable results.'
    },
    {
      icon: Rocket,
      title: 'Innovation-Driven',
      description: 'Leveraging cutting-edge technologies and agile methodologies to keep you ahead in the digital race.'
    },
    {
      icon: Award,
      title: 'Quality Excellence',
      description: 'Certified professionals committed to delivering world-class solutions with rigorous quality assurance processes.'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Highly skilled professionals with Masters degrees and extensive experience from leading international firms.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-4">
            <span className="text-blue-600 font-semibold text-sm">ABOUT KAN DEEP AI</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Your Trusted Technology Partner for{' '}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
              Digital Excellence
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Kan Deep AI is a premier IT consulting and services company headquartered in Bangalore, India. We specialize in transforming businesses through innovative cloud solutions, enterprise applications, and cutting-edge digital technologies.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">Who We Are</h3>
            <p className="text-gray-700 leading-relaxed">
              Founded with a vision to empower businesses in their digital transformation journey, Kan Deep AI brings together a team of passionate technologists, strategic thinkers, and innovation catalysts.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our team comprises young, talented professionals, most holding Masters degrees in Computer Science, with proven track records at leading international technology firms. We combine academic excellence with real-world expertise to deliver solutions that matter.
            </p>
            <div className="flex items-start space-x-4 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <Award className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Our Mission</h4>
                <p className="text-gray-700">
                  To accelerate business growth by delivering innovative, scalable, and secure technology solutions that drive digital transformation and competitive advantage.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">Why Choose Us</h3>
            <div className="space-y-4">
              {[
                'Agile methodology for rapid delivery and flexibility',
                'Transparent communication throughout project lifecycle',
                'End-to-end solutions from concept to deployment',
                'On-time delivery with zero compromise on quality',
                'Certified developers with industry expertise',
                'Proven track record across 15+ countries',
                '24/5 development cycle for faster time-to-market',
                'Cost-effective solutions without hidden charges'
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group p-6 bg-white border border-gray-200 rounded-xl hover:shadow-xl hover:border-blue-300 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <value.icon className="w-7 h-7 text-white" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h4>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
